export enum LocalStorageLanguageProperty {
  LANGUAGE = "LANGUAGE",
  LANGUAGE_LABEL = "LANGUAGE_LABEL",
  LANGUAGE_ID = "LANGUAGE_ID",
}

export enum DEFAULT_TRANSLATION_LANGUAGES {
  DEFAULT = "default",
  US = "US",
}

export const DEFAULT_LANGUAGE_ID = "35";

export const TRANSLATION_DEFAULT = "default";

export interface TranslationsInterface {
  [LANG: string]: {
    [K: string]: string;
  };
}

export interface TranslationContextInterface {
  translations: TranslationsInterface;
  contextLanguage: string;
  setContextLanguage: (languageShortName: string) => void;
}

export interface OperationalLanguageInterface {
  id: number;
  name: string;
  localName: string;
  shortName: string;
}

export interface LanguageState {
  isLoading: boolean;
  error: string | undefined;
  data: OperationalLanguageInterface[] | [];
}

export interface OperationalLanguageOptionInterface {
  id: string;
  value: string;
  label: string;
}
